import React, { Component } from 'react'
import ModalVideo from 'react-modal-video'
import ReactPlayer from 'react-player'
import $ from 'jquery';

class YTPlayer extends Component {
    componentDidUpdate() {
        setTimeout(function(){
            var modelCloseButton =  $(".modal-video-close-btn");
            modelCloseButton.attr("accesskey","c");
            modelCloseButton.attr("tabindex","0");
            modelCloseButton.attr("aria-label","modal-close");
            modelCloseButton.attr("aria-description","close the modal");
        },200);
    }

    constructor(props){
        super(props)
        this.state = {
            isOpen: false,
            isPlaying: false
        }
        this.openModal = this.openModal.bind(this)
        this.closeModal = this.closeModal.bind(this)
    }

    openModal () {
        this.setState({isOpen: true})
        this.setState({isPlaying: true})
        this.setState({isPlaying: false})
    }

    closeModal () {
        this.setState({isOpen: false})
    }

    render(){

        return (
            <React.Fragment>
                <ModalVideo channel='youtube' youtube={{autoplay:1}} isOpen={this.state.isOpen} videoId={this.props.src} onClose={this.closeModal} />
                <ReactPlayer style={{margin: 'auto', paddingBottom: '2%'}} height='360px' width= '640px'url={"https://www.youtube.com/watch?v="+ this.props.src} onPlay={this.openModal} playing={this.state.isPlaying}/>
            </React.Fragment>
        )
    
    }

}

export default YTPlayer;
